module.exports = __webpack_public_path__ + "img/biome-frame.2eee4ea0.png";